var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"calendar-grid"},[_vm._l((_vm.weekDays),function(d,i){return _c('div',{key:i,staticClass:"day-name"},[_vm._v(_vm._s(d))])}),_vm._l((_vm.calendarDays),function(day){return _c('div',{key:day.format('YYYY-MM-DD'),staticClass:"day",class:{
        selected: _vm.isSelected(day),
        otherMonth: !_vm.isCurrentMonth(day)
      },on:{"click":function($event){return _vm.toggleDate(day)}}},[_vm._v("\n      "+_vm._s(day.date())+"\n    ")])})],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }